import { useQuery } from "@tanstack/react-query";
import type { TiposSeleccionFiltroStock } from "./FiltroArticulos";
import { ComunicacionAjax } from "../../../ts/api/comunicacion";
import { ModalCrearOF } from "../../../components/modals/CrearOF";
import { useMemo, useState } from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { TypedTable } from "../../../components/TypedTable";
import { Loading, QueryError } from "../../../components/Loading/Loading";

interface TablaArticulosProps { readonly familia: string[]; readonly subfamilia: string[]; readonly stock: TiposSeleccionFiltroStock; readonly tipoArticulo: string[]; }
export function TablaArticulos(props: TablaArticulosProps) {
	const { data, error, isPending } = UseArticulos({
		idsFamilia: props.familia,
		idsSubFamilia: props.subfamilia,
		tipo: props.stock,
	});

	const [artCreandoOF, setArtCreandoOF] = useState<string | null>(null);


	const columns = useMemo(() => {
		const columnHelper = createColumnHelper<ArticuloFabricacion>();
		const formatter = new Intl.NumberFormat("es-ES", { maximumFractionDigits: 2, minimumFractionDigits: 0 });
		const defaultNumberFormat = (value: number | null) => value != null ? formatter.format(value) : "-";

		const getAccionesArticulo = (articulo: ArticuloFabricacion) => {
			if ((articulo.tipoArticulo == 2 || articulo.tipoArticulo == 5) && articulo.rutaFabricacion != null) {
				return (
					<div className="clickable mostrarModalLanzarOF" data-id-articulo={articulo.idArticulo}>
						<i className="fa fa-plus" />
					</div>
				);
			} else {
				return <div style={{ width: "36px" }} />;	// placeholder to somewhat keep the column width consistent
			}
		};

		return [
			columnHelper.accessor("nombreFamilia", { header: "Familia", cell: info => info.getValue() ?? "-", meta: { className: "dt-center" } }),
			columnHelper.accessor(info => `${info.idArticulo} - ${info.nombreArticulo}`, { id: "articulo", header: "Artículo", meta: { className: "dt-center" } }),

			// columnHelper.accessor("m382_xpeso", { header: "Peso", cell: info => defaultNumberFormat(info.getValue()), meta: { className: "dt-center" } }),
			columnHelper.accessor("max", { header: "Máximo", cell: info => defaultNumberFormat(info.getValue()), meta: { className: "dt-center" } }),
			columnHelper.accessor("min", { header: "Mínimo", cell: info => defaultNumberFormat(info.getValue()), meta: { className: "dt-center" } }),
			columnHelper.accessor("pendienteEntrada", { header: "Pdte. Entrada", cell: info => defaultNumberFormat(info.getValue()), meta: { className: "dt-center" } }),
			columnHelper.accessor("pendienteSalida", { header: "Pdte. Salida", cell: info => defaultNumberFormat(info.getValue()), meta: { className: "dt-center" } }),
			columnHelper.accessor("stock", { header: "Existencias", cell: info => defaultNumberFormat(info.getValue()), meta: { className: "dt-center" } }),
			columnHelper.accessor("entrarRecomendado", { header: "PEDIR", cell: info => defaultNumberFormat(info.getValue()), meta: { className: "dt-center" } }),
			// columnHelper.accessor("ped_lista", { header: "Pdte. Empaquetar", cell: info => defaultNumberFormat(info.getValue()), meta: { className: "dt-center" } }),

			columnHelper.display({
				id: "actions",
				header: "",
				meta: { className: "p-0 h-full" },
				cell: ({ row }) => getAccionesArticulo(row.original),
			}),

		];
	}, []);

	const filteredData = useMemo(() => {
		if (!data) return data;
		if (props.tipoArticulo.length === 0) return data;

		return data.filter(art => props.tipoArticulo.includes(String(art.tipoArticulo)));
	}, [data, props.tipoArticulo]);

	if (error) return <QueryError error={error} fallback="Error al cargar los artículos" />;
	if (isPending) return <Loading />;

	const onClickDT = (event: React.MouseEvent<HTMLDivElement>) => {
		const target = (event.target as HTMLElement | null)?.closest(".mostrarModalLanzarOF") as HTMLElement | null;
		if (!target) {
			return;
		}
		const idArticulo = target.dataset.idArticulo;
		if (idArticulo) {
			setArtCreandoOF(idArticulo);
		}
	};
	return <>
		<div onClick={onClickDT}>
			<TypedTable
				// "scrollY": "600px",
				// "scrollCollapse": true,
				// "orderClasses": false,
				// "dom": "T<\"clear\">lfrtip",
				// "paging": true,
				className="dataTable display"
				data={filteredData ?? []}
				columns={columns}

				pagination
				globalSearch
			/>
		</div>

		<ModalCrearOF
			show={artCreandoOF != null}
			close={() => setArtCreandoOF(null)}
			idArticulo={artCreandoOF}
		/>
	</>;
}
interface UseArticulosParams {
	idsFamilia: string[];
	idsSubFamilia: string[];
	tipo: TiposSeleccionFiltroStock;
}
function UseArticulos(parametros: UseArticulosParams) {
	return useQuery<ArticuloFabricacion[]>({
		queryKey: ["getArticulosStock", parametros],
		queryFn: () => {
			return ComunicacionAjax.sendAjaxRequest<ArticuloFabricacion[]>("GET", "/getArticulosStock", parametros);
		}
	});
}
interface ArticuloFabricacion {
	idArticulo: number;
	nombreArticulo: string;
	nombreFamilia: string | null;
	nombreSubFamilia: string | null;
	rutaFabricacion: string | null;
	tipoArticulo: number | null;

	stock: number | null;
	pendienteEntrada: number | null;
	pendienteSalida: number | null;
	entrarRecomendado: number;
	max: number | null;
	min: number | null;
}